import moment from "moment";
import toast from "react-hot-toast";

export const getApiErrorMessage = (error) => {
  const data = error?.response?.data;
  if (!data) return null;
  return data?.error?.message || data?.message || null;
};

export const showApiError = (error) => {
  const message = getApiErrorMessage(error);
  if (message) toast.error(message);
};

export const getInitials = (name) => {
  if (!name) return null;

  const nameParts = name.trim()?.split(" ");
  if (nameParts) {
    const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
    return initials.toUpperCase();
  }
};

export const qs = (params) => {
  if(typeof params === "string") return params;
  if (!params || typeof params !== "object") return "";
  const queryString = new URLSearchParams(params).toString();
  return queryString ? `${queryString}` : "";
};

export const formatDate = (date, format = "DD-MM-YYYY, hh:mm A") => {
  if (!date || !moment(date).isValid()) return null;
  return moment(date).format(format);
};

export const formatePrice = (number) => {
  if (!number) return "$ 0";
  const formattedNumber = Number(Math.abs(number)).toFixed(2);
  return `$ ${formattedNumber}`
};

export const colors = {
  primary: { textColor: "#00727D", bgColor: "#E6F1F3" },
  secondary: { textColor: "#00BAD1", bgColor: "#D6F4F8" },
  success: { textColor: "#28C76F", bgColor: "#DDF6E8" },
  error: { textColor: "#FF4C51", bgColor: "#FFE2E3" },
  warning: { textColor: "#FF9F43", bgColor: "#FFF0E1" },
  info: { textColor: "#364153", bgColor: "#F3F4F6" },
};

export const getEnv = (key, defaultValue = "") => {
  const keyName = key.startsWith("REACT_APP_") ? key : `REACT_APP_${key}`;

  const value = process.env[keyName];
  return value || defaultValue;
};

export const getColor = (name, defaultValue = "") => {
  const varName = name.startsWith("--") ? name : `--${name}`;

  const rootStyles = getComputedStyle(document.documentElement);
  const value = rootStyles.getPropertyValue(varName).trim();
  return value || defaultValue;
};
